import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface EmailPreferences {
  vpThreshold: boolean;
  directorApproval: boolean;
  seApproval: boolean;
  seComponentWorkflow: boolean;
  seApproved: boolean;
  contractSigned: boolean;
}

@Injectable({ providedIn: 'root' })
export class EmployeeService {

  constructor(private httpClient: HttpClient) { }

  getEmailPreferences(azureAdId: string): Observable<EmailPreferences> {
    return this.httpClient.get<EmailPreferences>(`/api/Employees/${azureAdId}/emailpreferences`);
  }

  updateEmailPreferences(azureAdId: string, prefs: EmailPreferences): Observable<void> {
    return this.httpClient.put<void>(`/api/Employees/${azureAdId}/emailpreferences`, prefs);
  }

  isVpThresholdApprover(azureAdId: string): Observable<boolean> {
    return this.httpClient.get<boolean>(`/api/Employees/${azureAdId}/isvpthresholdapprover`);
  }

  isDirectorApprover(azureAdId: string): Observable<boolean> {
    return this.httpClient.get<boolean>(`/api/Employees/${azureAdId}/isdirectorapprover`);
  }
}